import axiosInstanceV2 from "../config/axios-v2-config";

/** Typed client for the FastAPI `/admin/*` API (replaces the Keycloak console). */

export interface RoleDto {
  id: string;
  name: string;
  description?: string | null;
}

export interface GroupDto {
  id: string;
  name: string;
  description?: string | null;
  roles: RoleDto[];
}

export interface UserDto {
  id: string;
  username: string;
  email?: string | null;
  full_name?: string | null;
  enabled: boolean;
  roles: RoleDto[];
  groups: GroupDto[];
  effective_roles: string[];
}

export interface SessionDto {
  id: string;
  user_id: string;
  username?: string | null;
  user_agent?: string | null;
  ip?: string | null;
  created_at: string;
  last_used_at?: string | null;
  expires_at: string;
  absolute_expires_at: string;
  revoked_at?: string | null;
  active: boolean;
}

// --- roles -----------------------------------------------------------------
export const listRoles = async (): Promise<RoleDto[]> =>
  (await axiosInstanceV2.get("/admin/roles")).data;

export const createRole = async (body: { name: string; description?: string }): Promise<RoleDto> =>
  (await axiosInstanceV2.post("/admin/roles", body)).data;

export const updateRole = async (id: string, body: { description?: string }): Promise<RoleDto> =>
  (await axiosInstanceV2.patch(`/admin/roles/${id}`, body)).data;

export const deleteRole = async (id: string): Promise<void> => {
  await axiosInstanceV2.delete(`/admin/roles/${id}`);
};

// --- groups ----------------------------------------------------------------
export const listGroups = async (): Promise<GroupDto[]> =>
  (await axiosInstanceV2.get("/admin/groups")).data;

export const createGroup = async (body: {
  name: string;
  description?: string;
  role_ids: string[];
}): Promise<GroupDto> => (await axiosInstanceV2.post("/admin/groups", body)).data;

export const updateGroup = async (
  id: string,
  body: { description?: string; role_ids?: string[] }
): Promise<GroupDto> => (await axiosInstanceV2.patch(`/admin/groups/${id}`, body)).data;

export const deleteGroup = async (id: string): Promise<void> => {
  await axiosInstanceV2.delete(`/admin/groups/${id}`);
};

// --- users -----------------------------------------------------------------
export const listUsers = async (): Promise<UserDto[]> =>
  (await axiosInstanceV2.get("/admin/users")).data;

export const createUser = async (body: {
  username: string;
  password: string;
  email?: string;
  full_name?: string;
  enabled?: boolean;
  role_ids?: string[];
  group_ids?: string[];
  id?: string;
}): Promise<UserDto> => (await axiosInstanceV2.post("/admin/users", body)).data;

export const updateUser = async (
  id: string,
  body: {
    email?: string;
    full_name?: string;
    enabled?: boolean;
    role_ids?: string[];
    group_ids?: string[];
  }
): Promise<UserDto> => (await axiosInstanceV2.patch(`/admin/users/${id}`, body)).data;

export const resetPassword = async (id: string, password: string): Promise<void> => {
  await axiosInstanceV2.post(`/admin/users/${id}/reset-password`, { password });
};

export const deleteUser = async (id: string): Promise<void> => {
  await axiosInstanceV2.delete(`/admin/users/${id}`);
};

// --- sessions --------------------------------------------------------------
export const listSessions = async (userId?: string): Promise<SessionDto[]> =>
  (
    await axiosInstanceV2.get("/admin/sessions", {
      params: userId ? { userId } : undefined,
    })
  ).data;

export const revokeSession = async (sessionId: string): Promise<void> => {
  await axiosInstanceV2.delete(`/admin/sessions/${sessionId}`);
};

export const revokeUserSessions = async (userId: string): Promise<void> => {
  await axiosInstanceV2.delete(`/admin/users/${userId}/sessions`);
};
